/**
 * Constantes de l'espace super-admin (v0.2) : version, libellés des actions du journal,
 * rôles et descriptions. Source unique réutilisée par toutes les pages admin.
 */

// Version plateforme : SOURCE UNIQUE partagée (établissement + super-admin).
// Un seul numéro à gérer, défini dans src/constants/version.js.
export { APP_VERSION } from '../../constants/version';

// Libellés lisibles des actions journalisées (clé technique → français).
export const ACTION_LABELS = {
  login: 'Connexion',
  user_create: 'Création utilisateur',
  user_update: 'Modification utilisateur',
  user_delete: 'Suppression utilisateur',
  user_block: 'Blocage utilisateur',
  user_unblock: 'Déblocage utilisateur',
  user_reset_password: 'Réinitialisation mot de passe',
  user_password_set: 'Mot de passe défini',
  user_access_sent: 'Email d’accès envoyé',
  user_impersonate: 'Connexion en tant que',
  tenant_create: 'Création établissement',
  tenant_update: 'Modification établissement',
  tenant_disable: 'Désactivation établissement',
  tenant_enable: 'Réactivation établissement',
  tenant_delete: 'Suppression établissement',
  tenant_export: 'Export établissement',
  appellation_create: 'Création appellation',
  appellation_update: 'Modification appellation',
  appellation_delete: 'Suppression appellation',
  appellations_import: 'Import appellations',
  config_import: 'Import configuration',
  export_config: 'Export configuration',
  export_journal: 'Export journal',
  export_tenants: 'Export établissements',
  export_users: 'Export utilisateurs',
  monthly_export: 'Export mensuel',
  settings_update: 'Mise à jour paramètres',
  log_purge: 'Purge du journal',
  log_clear: 'Journal effacé',
  email_sent: 'Email envoyé',
  server_error: 'Erreur serveur',
  api_error: 'Erreur API',
  login_failed: 'Échec de connexion',
};

// Actions sensibles → bleu foncé dans le journal.
export const SENSITIVE_ACTIONS = new Set([
  'user_delete', 'user_block', 'tenant_disable', 'tenant_delete', 'log_purge', 'log_clear',
]);

export const ROLES = ['gerant', 'sommelier', 'serveur'];
export const ROLE_LABELS = { gerant: 'Gérant', sommelier: 'Sommelier', serveur: 'Serveur' };
export const ROLE_DESCRIPTIONS = {
  gerant: 'Tous les droits : stock, données financières, paramètres et utilisateurs.',
  sommelier: 'Gère la cave, les achats et la carte ; pas d’accès aux utilisateurs ni aux réglages financiers.',
  serveur: 'Service uniquement : sorties et consultation, sans données financières.',
};

export const TENANT_TYPE_LABELS = { pro: 'Professionnel', particulier: 'Particulier' };
